import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {Constants} from '../../../core/services/constants.service';
import {TabService} from '../../../core/services/tab.service';
import {MatDialog} from '@angular/material/dialog';
import {EditProjectComponent} from '../edit/edit-project.component';
import {ManualUpdateDialogComponent} from '../project-detail/manual-update-dialog/manual-update-dialog.component';

@Component({
  selector: 'app-project-item',
  templateUrl: './project-item.component.html',
  styleUrls: ['./project-item.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})

export class ProjectItemComponent implements OnInit {
  @Input() project: any;
  @Input() layout: any;

  SERVER_URL = environment.SERVER_URL;
  logoUrl = '';
  statuses = [
    {
      id: -2,
      name: 'Invisible'
    },
    {
      id: -1,
      name: 'Under Approval'
    },
    {
      id: 0,
      name: 'Disabled'
    },
    {
      id: 1,
      name: 'Enable'
    }
  ];
  satusShow = '';
  constants = Constants;

  constructor(private router: Router, private cdr: ChangeDetectorRef, private tabService: TabService, private dialog: MatDialog, ) {

  }

  ngOnInit(): void {
    if (this.project.logo && this.project.logo.fileName) {
      this.logoUrl = encodeURI(this.SERVER_URL + 'images/' + this.project.projectCode + '/images/' + this.project.logo.fileName);
    }
    this.project.showBox = false;
    // this.cdr.detectChanges();
    this.statuses.forEach((item) => {
      if (item.id == this.project.status) {
        this.satusShow = item.name;
      }
    });
  }


  viewProject() {
    this.router.navigateByUrl('/projects/' + this.project.id).then(r => {
      // console.log('fff');
    });
  }

  goToEdit() {
    this.router.navigateByUrl('/projects/' + this.project.id + '/edit').then(r => {
      this.tabService.tabIndex = 0;
    });
  }

  goToAnalytics() {
    this.router.navigateByUrl('/projects/analytics/' + this.project.id).then(r => {
      // console.log('fff');
    });
  }

  goToCooperation() {
    this.router.navigateByUrl('/projects/cooperation/' + this.project.id).then(r => {
      // console.log('fff');
    });
  }

  goToCustomerContact() {
    this.router.navigateByUrl('/projects/customer-contact/' + this.project.id).then(r => {
      // console.log('fff');
    });
  }

  clickProjectItem() {
    this.router.navigateByUrl('/projects/' + this.project.id).then(r => {
      // console.log('fff');
    });
  }

  // clickMenu(event) {
  //   event.stopPropagation();
  //   console.log("method called");
  // }

  editproject(draft?: boolean) {
    const dialogRef = this.dialog.open(EditProjectComponent, {
      width: '816px',
      height: '800px',
      data: {project: this.project, draft},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      this.router.navigateByUrl('/projects');
    });
  }

  // review 更新时间
  openManulUpdateDialog() {
    const dialogRef = this.dialog.open(ManualUpdateDialogComponent, {
      width: '30%',
      data: {project: this.project},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        this.project.updateTime = result.data.updateTime;
      }
    });
  }
}
